const C = require("../constants");

const listProductIngredients = product_ingredients => {
    return {
        type: C.PRODUCT_INGREDIENTS,
        product_ingredients
    }
};

const removeProductIngredient = product_ingredient => {
    return {
        type: C.PRODUCT_INGREDIENTS_REMOVE,
        product_ingredient
    }
};

const addProductIngredient = product_ingredient => {
    return {
        type: C.PRODUCT_INGREDIENTS_ADD,
        product_ingredient
    }
};

export {
    listProductIngredients,
    removeProductIngredient,
    addProductIngredient,
};


// WEBPACK FOOTER //
// ./src/actions/ProductIngredientActions.js